import { render, staticRenderFns } from "./MassiveUpdatePage2.vue?vue&type=template&id=b1dd5cf6&lang=pug"
import script from "./MassiveUpdatePage2.vue?vue&type=script&lang=js"
export * from "./MassiveUpdatePage2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1dd5cf6')) {
      api.createRecord('b1dd5cf6', component.options)
    } else {
      api.reload('b1dd5cf6', component.options)
    }
    module.hot.accept("./MassiveUpdatePage2.vue?vue&type=template&id=b1dd5cf6&lang=pug", function () {
      api.rerender('b1dd5cf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/my_tasks/MassiveUpdatePage2.vue"
export default component.exports